import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { CleaningProcedureId } from "@brewbase/db/types";
import { TemplateBlockEditor } from "@/features/template-block-editor/template-block-editor";
import { useCleaningEditorConfig } from "@/features/cleaning-procedure/template-block-editor-adapter";

export const Route = createFileRoute(
  "/settings/cleaning-procedures/$procedure_id/fields",
)({
  component: RouteComponent,
  params: z.object({
    procedure_id: z.coerce
      .number()
      .transform((val) => val as CleaningProcedureId),
  }),
});

function RouteComponent() {
  const { procedure_id } = Route.useParams();
  const config = useCleaningEditorConfig(procedure_id);
  return <TemplateBlockEditor config={config} />;
}
